import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { Input } from 'src/@/components/ui/input';
import v2_actionEditarPipeline from 'src/actions/v2/crm/v2_actionEditarPipeline';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function PopoverEditarEstagio({
  open,
  cliente,
  pipelineStage,
  onClose,
  onCallback,
}) {
  const { t } = useTranslation('settings');
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleEditarPipilene(scope) {
    try {
      setLoading(true);
      await v2_actionEditarPipeline(pipelineStage?._id, {
        action: 'editar_pipeline_stage',
        scope,
      }, cliente._id);
      onCallback();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setNome(pipelineStage?.nome || '');
  }, [pipelineStage]);

  return (
    <Popover open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <PopoverTrigger asChild>
        <div />
      </PopoverTrigger>
      <PopoverContent
        className="w-80 p-5 border border-[#e7e7ec] rounded-[12px] shadow-none"
        style={{ fontFamily: D.fontStack }}
        align="start"
      >
        <div className="flex flex-col gap-4">
          <div className={D.field}>
            <label className={D.label}>{t('labels.name', { ns: 'common' })}</label>
            <Input
              value={nome}
              onChange={(event) => setNome(event.target.value)}
              className={D.input}
            />
          </div>
          <button
            type="button"
            disabled={loading || !nome?.trim()}
            onClick={() => handleEditarPipilene({ nome })}
            className={D.primaryButton}
          >
            {loading ? t('funnel.core.stagePopover.savingButton', 'Salvando...') : t('buttons.save', { ns: 'common' })}
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
